// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reports-card.content-tab{height:calc(100vh - 160px)!important}.reports-card.content-tab>*{min-height:100%}.reports-tabs .v-tabs__item{text-transform:none}", ""]);
// Exports
module.exports = exports;
